<script>
import baseList from "@/views/components/base/baseList.vue";
let customerId = window.localStorage.getItem("customerId");
import { Tag, Button } from "view-design";
import Vue from "vue";
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "category",
        key: "id",
        url: {
          list: "/admin/system/patrolType/list",
          del: "/admin/system/patrolType",
        },
        output: false,
      },
      actions: [
        {
          label: "新增",
          icon: "md-add",
          onClick: this.toAdd,
          type: "info",
          auth: "",
        },
      ],
      menus: [],
      filters: [
        {
          label: "巡检类别",
          KeyEnter: this.search,
          name: "sceneName",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "巡检类别",
          key: "typeName",
          width: 300,
          align: "left",
        },
        {
          title: "巡检项",
          key: "patrolSceneList",
          minWidth: 300,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            let patrolSceneArr = [];
            row.patrolSceneList.forEach((item) => {
              patrolSceneArr.push(item.sceneName);
            });
            const patrolSceneStr = patrolSceneArr.join(",");
            return <span>{patrolSceneStr}</span>;
          },
        },
        // {
        //   title: '场景地址',
        //   key: 'address',
        //   minWidth: 120,
        //   align: 'left',
        // },
        {
          title: "创建时间",
          width: 150,
          align: "center",
          key: "createTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.createTime.slice(0, 16);
            // console.log(text);
            let result = "";
            var n = 10; //指定第n位换行
            for (var i = 0, len = text.length; i < len; i++) {
              result += text[i];
              if ((i + 1) % n == 0) result += "\r\n";
            }
            return <span>{result}</span>;
          },
        },
        // {
        //   title: '备注',
        //   minWidth: 180,
        //   align: 'left',
        //   key: 'remark',
        // },
        {
          title: "操作",
          align: "center",
          width: 150,
          key: "handle",
          fixed: "right",
          handle: ["edit", "delete"],
        },
      ],
    };
  },
  created() {},
  methods: {
    toAdd() {
      $utils.url.push({ name: "category_edit", query: { action: "add" } });
    },
    handleEdit(row) {
      let kv = row.id;
      $utils.url.push({
        name: "category_edit",
        query: { action: "edit", kv: kv },
      });
    },
  },
};
</script>
<style scoped></style>
